<template>
  <div
    @click="handleClick"
    class="story-card relative block rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col group"
    :class="{ 'cursor-pointer': !isActive, 'cursor-default': isActive }"
  >
    <div class="p-6 flex-grow">
      <h2 class="text-xl font-bold story-title mb-2 group-hover:text-blue-500 transition-colors duration-300">{{ story.name }}</h2>
      <h3 class="text-sm story-author mb-2">Tác giả: {{ story.author }}</h3>
      <div class="text-xs story-author mb-3 flex items-center">
        <i class="fa-solid fa-list-ol w-4 text-center mr-1.5"></i>
        <span>{{ story.chapter_count }} chương</span>
      </div>
      <p class="story-genre text-xs">
        <i class="fa-solid fa-tag mr-1"></i>
        <i>{{ story.genres.join(', ') }}</i>
      </p>
    </div>

    <template v-if="!isActive">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-[2px] hidden md:flex items-center justify-center opacity-0 group-hover:opacity-60 transition-opacity duration-300">
        <i class="fa-solid fa-circle-play text-6xl text-white/80"></i>
      </div>
      <div class="absolute bottom-4 right-4 md:hidden">
          <div class="w-10 h-10 rounded-full bg-blue-600/80 flex items-center justify-center text-white">
              <i class="fa-solid fa-headphones"></i>
          </div>
      </div>
    </template>

    <div v-else class="absolute inset-0 bg-black/70 flex items-center justify-center">
        <div class="flex items-center gap-3 text-white">
            <i class="fa-solid fa-waveform text-2xl"></i>
            <span class="font-bold text-lg">Đang phát</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoryCard',
  props: {
    story: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select-story'],
  methods: {
    handleClick() {
      // Chỉ phát sự kiện khi truyện chưa được kích hoạt
      if (!this.isActive) {
        this.$emit('select-story', this.story.slug);
      }
    }
  }
};
</script>

<style scoped>
/* Giữ nguyên các style từ file index.html */
.story-card {
    background-color: var(--card-bg-color);
    border: 1px solid var(--border-color);
    transition: border-color 0.3s, transform 0.3s, box-shadow 0.3s;
}
.story-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    border-color: var(--primary-color);
}
.story-card-footer { background-color: var(--card-footer-bg); }
.story-title { color: var(--text-color); }
.story-author { color: var(--text-muted-color); }
.story-genre { color: var(--text-muted-color); }
</style>
